import { useLocation, useNavigate } from "react-router-dom";
import { googleReviews, logo, phone, socials, whatsapp } from "@/data/site";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const go = id => {
    const scroll = () => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(scroll, 400);
    } else scroll();
  };
  return (
    <footer>
      <div className="footer-brand"><img src={logo} alt="ADVOKIT" /><p>The practical edge for law students and young lawyers.</p>
        <a className="g-badge" data-testid="footer-google-badge" href={googleReviews.url} target="_blank" rel="noreferrer">
          <img src="/images/google-g.svg" alt="Google" />
          <span className="g-badge-stars">★★★★★</span>
          <span className="g-badge-text">{googleReviews.rating} on Google · {googleReviews.count} reviews</span>
        </a>
      </div>
      <div className="footer-links">
        <div>
          <strong>Explore</strong>
          <button data-testid="footer-courses-link" onClick={() => go("courses")}>Courses</button>
          <button data-testid="footer-blogs-link" onClick={() => navigate("/blogs")}>Blogs</button>
          <button data-testid="footer-resources-link" onClick={() => go("resources")}>Resources</button>
        </div>
        <div>
          <strong>Connect</strong>
          <a data-testid="footer-whatsapp-link" href={whatsapp} target="_blank" rel="noreferrer">WhatsApp us</a>
          <a data-testid="footer-email-link" href={`mailto:${socials.email}`}>Email ADVOKIT</a>
          <a data-testid="footer-phone-link" href={`tel:${phone}`}>+91 7309 606 226</a>
        </div>
        <div>
          <strong>Follow</strong>
          <a data-testid="footer-facebook-link" href={socials.facebook} target="_blank" rel="noreferrer">Facebook</a>
          <a data-testid="footer-instagram-link" href={socials.instagram} target="_blank" rel="noreferrer">Instagram</a>
          <a data-testid="footer-youtube-link" href={socials.youtube} target="_blank" rel="noreferrer">YouTube</a>
          <a data-testid="footer-telegram-link" href={socials.telegram} target="_blank" rel="noreferrer">Telegram</a>
          <a data-testid="footer-linkedin-link" href={socials.linkedin} target="_blank" rel="noreferrer">LinkedIn</a>
        </div>
      </div>
      <div className="footer-bottom"><span>© 2026 ADVOKIT. Practical legal education.</span><span>Learn. Practice. Build.</span></div>
    </footer>
  );
}
